<!-- <p>
  drzava-update works!
</p> -->
<form [formGroup]="baseFormGroup" #f="ngForm" class="mt-4 pl-2">
  <div class="form-horizontal">
    <div class="row">
      <div class="col-md-6">
        <div class="form-group row">
          <!-- <label class="col-form-label col-3"><span>Ime</span></label> -->
          <div class="col-md-12">
            <yt-input
              [Type]="'text'"
              name="txtFirstName"
              formControlName="FirstName"
              #focusElement
              [MaxLength]="200"
              [Label]="'USER.IME.SINGULAR'"
              #autofocus>
            </yt-input>
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group row">
          <!-- <label class="col-form-label col-3"><span>Prezime</span></label> -->
          <div class="col-md-12">
            <yt-input
              [Type]="'text'"
              name="txLastName"
              formControlName="LastName"
              [MaxLength]="200"
              [Label]="'USER.PREZIME.SINGULAR'">
            </yt-input>
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group row">
          <!-- <label class="col-form-label col-3"><span>Korisničko ime</span></label> -->
          <div class="col-md-12">
            <yt-input
              [Type]="'text'"
              name="txUserName"
              formControlName="UserName"
              [MaxLength]="200"
              [Label]="'USER.KORISNICKOIME.SINGULAR'">
            </yt-input>
          </div>
        </div>
      </div>
      <div class="col-md-6" *ngIf="isNew">
        <div class="form-group row">
          <div class="col-md-11 mx-auto">
            <yt-input
              [Type]="showPassword ? 'text' : 'password'"
              name="txtPassword"
              formControlName="Password"
              [Label]="'USER.PASSWORD.SINGULAR'">
          </yt-input>         
          <!-- <div class="form-error" *ngIf="submitted && fc.Password.invalid">
            <span *ngFor="let validation of errorMessages.Password">
              <span class="error-message" *ngIf="fc.Password.hasError(validation.type)"><span
                  translate="{{validation.message}}"></span></span>
            </span>
          </div> -->

          </div>
          <div class="col-md-1" style="padding-top: 22px">
              <i alt="show" class="far fa-eye eye-show"
              (click)="showPassword = !showPassword"
               [ngClass]="{'d-none' : showPassword}"></i>
             <i alt="hide" class="far fa-eye-slash eye-hide"
              (click)="showPassword = !showPassword"
              [ngClass]="{'d-none' : !showPassword}"></i>
          </div>
        </div>
        <div class="form-error" *ngIf="submitted && fc.Password.invalid">
          <span *ngFor="let validation of errorMessages.Password">
            <span class="error-message" *ngIf="fc.Password.hasError(validation.type)"><span
                translate="{{validation.message}}"></span></span>
          </span>
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group row">
          <div class="col-md-12">
            <yt-input
              [Type]="'text'"
              name="txtEmail"
              formControlName="Email"
              [Label]="'USER.EMAIL.SINGULAR'">
            </yt-input>
          </div>
        </div>
      </div>

      <div class="col-md-6">
        <div class="form-group row">
          <div class="col-md-12">
            <yt-input
              [Type]="'text'"
              name="txtPhoneNumber"
              formControlName="PhoneNumber"
              #focusElement
              [MaxLength]="30"
              [Label]="'USER.PHONE.SINGULAR'"
              #autofocus>
            </yt-input>
          </div>
        </div>
      </div>



        <!-- <div class="form-group row">
          <label class="col-form-label col-3"><span>Šifra</span></label>
          <div class="col-md-9">
            <input
              type="password"
              name="txtPassword"
              class="form-control"
              [(ngModel)]="Item.Password"
              autofocus
              required
              #Password="ngModel"
              autocomplete="off">
          </div>
        </div> -->
        <!-- <div class="form-group row">
          <label class="col-form-label col-3"><span>Ponovi šifru</span></label>
          <div class="col-md-9">
            <input
              type="password"
              name="txtConfirmPassword"
              class="form-control"
              [(ngModel)]="Item.ConfirmPassword"
              autofocus
              required
              #ConfirmPassword="ngModel"
              autocomplete="off">
          </div>
        </div> -->
        <div class="col-md-6">
          <div class="form-group row">
            <div class="col-md-12">                
              <yt-dropdown-picklist 
                [ModelName]="'firma'" 
                [GetName]="'get'" 
                [ModelProperty]="'Naziv'"
                [OrderBy]="'Naziv'" 
                [AllowAddNew]="false"
                [AllowEdit]="false" 
                formControlName="CompanyID"
                [Label]="'USER.FIRMA.SINGULAR'">
            </yt-dropdown-picklist>
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group row">
            <div class="col-md-12">
              <yt-dropdown-picklist 
              [ModelName]="'orgjed'" 
              [GetName]="'get'" 
              [ModelProperty]="'Naziv'"
              [OrderBy]="'Naziv'" 
              [AllowAddNew]="false" 
              formControlName="OrgJedID"
              [Label]="'USER.ORGJEDID.SINGULAR'">
              </yt-dropdown-picklist>
          </div>
          </div>
        </div>
        <div class="col-md-6">
        <div class="form-group row">
          <!-- <label class="col-form-label col-3"><span>Korisnička rola</span></label> -->
          <div class="col-md-12">
            <yt-dropdown-picklist 
            [ModelName]="'userrole'" 
            [GetName]="'get'" 
            [ModelProperty]="'Name'"
            [OrderBy]="'Name'" 
            [AllowAddNew]="false" 
            formControlName="RoleID"
            name="cmbUserRole"
            [Label]="'USER.KORISNICKAROLA.SINGULAR'">
            </yt-dropdown-picklist>
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group row">
          <!-- <label class="col-form-label col-3"><span>Jezik</span></label> -->
          <div class="col-md-12">
            <yt-dropdown-picklist 
            [ModelName]="'language'" 
            [GetName]="'get'" 
            [ModelProperty]="'Name'"
            [OrderBy]="'Name'" 
            [AllowAddNew]="false" 
            formControlName="LanguageID"
            name="cmbUserRole"
            [Label]="'USER.JEZIK.SINGULAR'">
            </yt-dropdown-picklist>
          </div>
        </div>

      </div>
      <div class="form-group row" style="padding-left: 20px;">
        <div class="col-md-1">
          <input
            style="width: 20px;"
            type="checkbox"
            name="chkActive"
            class="form-control"
            formControlName="is_active"
            autocomplete="on"
            id="chkActive"
            >
        </div>
        <label class="col-form-label col-2" for="chkActive"><span translate="USERPROVAJDER.ISACTIVE.SINGULAR"></span></label>
      </div>
    </div>
  </div>
</form>
<form [formGroup]="orgJedFormGroup" class="mt-4">
  <div class="form-horizontal">
    <div class="row mt-4">
      <div class="col-md-6">
        <div class="row">
          <div class="col-md-8">
            <yt-dropdown-picklist 
            [ModelName]="'orgjed'" 
            [GetName]="'get'" 
            [ModelProperty]="'Naziv'"
            [OrderBy]="'Naziv'" 
            [AllowAddNew]="false" 
            formControlName="selectedOrgJedID"
            name="cmbUserRole"
            [Label]="'USER.ORGJEDID.SINGULAR'">
            </yt-dropdown-picklist>
            <!-- <yt-fw-dropdown
              [ModelName]="'orgjed'"
              [GetName]="'get'"
              [ModelProperty]="'Naziv'"
              [OrderBy]="'Naziv'"
              [AllowAddNew]="false"
              formControlName="selectedOrgJedID"
              [Type]="'ID'"
              [Label]="'USER.ORGJEDID.SINGULAR'">
            </yt-fw-dropdown> -->
          </div>
          <div class="col-md-4">
            <button type="button" class="btn btn-outline-primary" (click)="AddOrgJedToUser()">Dodaj</button>
          </div>
        </div>
      </div>
      <div class="col-md-6">
      </div>
    </div>
  </div>
</form>